import tokens from "../../smart-tokens/build/json/variables.json";
import type {Color} from "@utils/types";

const getColorByToken = (name: string): Color => {
	return tokens[name] || name;
};

export { tokens, getColorByToken };